const getters = {
    kycIncidentHeaders: (state) => state.kycIncidents.headers
}

export default getters;
